import { Platform } from "quasar";

import { track } from "shared/boot/analytics";
import { $streemApiV1 } from "shared/boot/api";
import { downloadFile } from "shared/helpers/file";

function openChannelTranscript(channelId, params) {
  track("Transcript Downloaded", { type: "channel" });

  return $streemApiV1
    .get(`channels/${channelId}/transcript.pdf`, {
      params,
      responseType: "blob",
    })
    .then(({ data }) => {
      downloadFile({
        data,
        filename: "transcript",
        format: "pdf",
      });
    });
}

function openExternalUrl(url, redirect) {
  const decodedUrl = decodeURIComponent(url);

  if (redirect && !Platform.is.capacitor) {
    window.location.href = decodedUrl;

    return;
  }

  window.open(decodedUrl, "_blank");
}

function openExternalUrlForMention(mention, router, redirect = false) {
  if (
    Platform.is.android &&
    ((mention.url && /\.pdf$/i.test(mention.url)) ||
      mention.medium === "Social")
  ) {
    openSystemBrowser(mention.authenticated_url || mention.public_link);
  } else if (router && /\.streem\.(com\.au|media)/.test(mention.url)) {
    const pathname = mention.url.match(/(?:^|\w+:\/\/.+?)(\/.+)/)[1];
    router.push(pathname);
  } else {
    openExternalUrl(
      mention.authenticated_url || mention.public_link || mention.url,
      redirect
    );
  }
}

function openLink(link, options) {
  return Platform.is.mobile
    ? openSystemBrowser(link)
    : openExternalUrl(link, options);
}

function openPdf(url) {
  if (Platform.is.android) {
    openSystemBrowser(url);
  } else {
    openExternalUrl(url);
  }
}

function openProgramTranscript(programAiringId, params) {
  track("Transcript Downloaded", { type: "program" });

  return $streemApiV1
    .get(`tv_program_airings/${programAiringId}/transcript.pdf`, {
      params,
      responseType: "blob",
    })
    .then(({ data }) => {
      downloadFile({
        data,
        filename: "transcript",
        format: "pdf",
      });
    });
}

function openSystemBrowser(url) {
  if (Platform.is.capacitor) {
    window.location = url;

    return;
  }

  window.open(url, "_system");
}

export {
  openChannelTranscript,
  openExternalUrl,
  openExternalUrlForMention,
  openLink,
  openPdf,
  openProgramTranscript,
  openSystemBrowser,
};
